
import React from "react";
import * as Material from "@mui/material";
import { ArrowDropDownRounded } from "@mui/icons-material";

export default function Filter({ name, valueLabel, onClick, icon, customComponent, className }) {
    return (
        <div className={`filter-item pressable ${className}`} onClick={(e) => {
            if (!customComponent) {
                onClick(e);
            }
        }}>
            {icon && <span className="filter-icon">{icon}</span>}
            <span>{name}</span>
            <Material.Divider orientation="vertical" flexItem />
            {
                customComponent ? customComponent : <span className="bold">{valueLabel}</span>
            }
            <ArrowDropDownRounded />
        </div>
    )
}
